import { Equal, IQueryCommandOptions, Not } from '@llws/dynamic-router-utils';
import { IFloorplanNavigatorInstances } from '@llws/lift-entity-interfaces';
import { StoreBaseImplementationV2 } from '../../shared/classes/store-base-implementation-v2';
import { IAction, IStateStrict } from '@/shared/interfaces/store-base';
import { IModifyPayload } from '@/shared';

const adminGatewayResourcePath: string = '/web-components-api/floorplan_navigator_instances';
const listViewName: string = '';
const showLogging: boolean = false;
const defaultGetListFilters: IQueryCommandOptions = {
  relations: [
    { path: 'fpni.floorplanNavigatorPreset', alias: 'fpnp' },
    { path: 'fpni.sitesHasFloorplanNavigatorInstances', alias: 'shfpni', whereCommands: [ Not(Equal('status', 'deleted')) ] },
    { path: 'shfpni.site', alias: 's' },
    { path: 'fpni.buildings', alias: 'b' },
  ],
  select: [
    'fpni.id',
    'fpni.floorplanNavigatorPresetId',
    'fpni.layout',
    'fpni.key',
    'fpni.version',
    'fpni.launchDate',
    'fpnp.id',
    'fpnp.name',
    'shfpni.siteId',
    'shfpni.floorplanNavigatorInstanceId',
    'shfpni.domain',
    'shfpni.recaptchaSiteKey',
    'shfpni.recaptchaPrivateKey',
    'shfpni.status',
    'b.id',
    'b.buildingName',
    's.name',
    's.id',
    's.siteUrl',
  ],
  where: [
    Not(Equal('fpni.status', 'deleted')),
  ],
  limit: 'false',
  alias: 'fpni',
};
const defaultGetSingleFilters: IQueryCommandOptions = {
  alias: 'fpni',
  relations: [
    { path: 'fpni.floorplanNavigatorPreset', alias: 'fpnp' },
    { path: 'fpni.sitesHasFloorplanNavigatorInstances', alias: 'shfpni', whereCommands: [ Not(Equal('status', 'deleted')) ] },
    { path: 'fpni.fpnInstanceHasBuildings', alias: 'fpnihb' },
    { path: 'fpnihb.building', alias: 'hb' },
    { path: 'fpni.buildings', alias: 'b' },
    { path: 'fpni.fpnInteractables', alias: 'i' },
    { path: 'shfpni.site', alias: 's' },
  ],
  select: [
    'fpni.id',
    'fpni.clientId',
    'fpni.floorplanNavigatorPresetId',
    'fpni.layout',
    'fpni.key',
    'fpni.version',
    'fpni.buildingImage',
    'fpni.branding',
    'fpni.fonts',
    'fpni.usePanzoomOnBuilding',
    'fpni.usePanzoomOnFloormap',
    'fpni.modalStyle',
    'fpni.hauzdSettings',
    'fpni.noResults',
    'fpnp.id',
    'shfpni.siteId',
    'shfpni.floorplanNavigatorInstanceId',
    'shfpni.domain',
    'shfpni.recaptchaSiteKey',
    'shfpni.recaptchaPrivateKey',
    'shfpni.status',
    'shfpni.environment',
    'shfpni.liveDate',
    'fpnihb.id',
    'fpnihb.buildingId',
    'fpnihb.toursQueryString',
    'b.id',
    'b.buildingName',
    'hb.id',
    'hb.buildingName',
    's.siteUrl',
    'i.id',
    'i.sourceModelId',
    'i.sourceModelType',
    'i.targetModelId',
    'i.targetModelType',
  ],
};
const base = new StoreBaseImplementationV2<IFloorplanNavigatorInstances>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

export default {
  namespaced: base.namespaced,

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
  },
};
